module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h1"
  }, [_c('strong', [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _c('a', {
    attrs: {
      "id": "ch002_title"
    }
  }), _vm._v("Victory Girls, Khaki-Wackies, and Patriotutes")])]), _vm._v(" "), _c('p', {
    staticClass: "bsubtitleleftg"
  }, [_c('em', [_vm._v("The Regulation of Female Sexuality during World War II")])]), _vm._v(" "), _c('p', {
    staticClass: "authorleft"
  }, [_vm._v("Marilyn E. Hegarty")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0003-1.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1afbbfda","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch002_title.vue
// module id = 63
// module chunks = 0